import React, { useCallback } from 'react'
import useLanguage from '../hooks/useLanguage'
import useShips from '../hooks/useShips'
import Cruise from '../types/Cruise'
import { getDateFormat } from '../utils/dates'
import CloseCruise from './CloseCruise'
import ShipName from './ShipName'

type Props = {
  onPressQuit: () => void

  cruise: Cruise
}

const MapCruiseModal: React.FC<Props> = ({ onPressQuit, cruise }: Props) => {
  const { ships } = useShips()
  const language = useLanguage()

  const getShipName = useCallback(() => {
    if (ships.length > 0) {
      return ships[ships.findIndex((value) => value.code === cruise.ship_id)].name
    }
  }, [cruise, ships])

  return (
    <div className='cruise--mapInfo'>
      <CloseCruise onClick={onPressQuit} />
      <div className='marker--infoSection'>
        <ShipName name={getShipName() || ''} />
        <div className='text'>
          {cruise.cruise_name[language]}
        </div>
        <div className='modal--cruise--content--all text text--size14 text--gray'>
          {getDateFormat(cruise.cruise_start, cruise.cruise_end, language)}
        </div>
      </div>
    </div>
  )
}

export default MapCruiseModal
